if (!customElements.get('group-buy-form')) {
  customElements.define('group-buy-form', class GroupBuyForm extends HTMLElement {
    constructor() {
      super();
      this.items = this.querySelectorAll('group-buy-item');
      this.totalPriceEl = this.querySelector('#group-buy-total-price');
      this.totalComparePriceEl = this.querySelector('#group-buy-total-compare');
      this.addToCartBtn = this.querySelector('#group-buy-add-to-cart');
      this.errorEl = this.querySelector('#group-buy-error');
      this.cartEligibleQty = 0;
      this._abortController = new AbortController();

      this.init();
    }

    disconnectedCallback() {
      // Remove document-level listeners when element is removed from DOM
      this._abortController.abort();
    }

    init() {
      this.items.forEach(item => {
        const selects = item.querySelectorAll('.group-buy-select');
        const radios = item.querySelectorAll('.group-buy-radio');
        const quantityInput = item.querySelector('.group-buy-quantity');

        selects.forEach(select => {
          select.addEventListener('change', () => this.onVariantChange(item));
        });

        // radio 按钮选中时，同步隐藏 select 的值并更新选中值显示
        radios.forEach(radio => {
          radio.addEventListener('change', () => {
            const optionIndex = radio.dataset.optionIndex;
            const hiddenSelect = item.querySelector(`.group-buy-select[data-index="${optionIndex}"]`);
            if (hiddenSelect) {
              hiddenSelect.value = radio.value;
              // 更新当前选项名称显示（legend 中的 data-selected-option-value）
              const fieldset = radio.closest('fieldset');
              if (fieldset) {
                const labelEl = fieldset.querySelector('[data-selected-option-value]');
                if (labelEl) labelEl.textContent = radio.value;
              }
              hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });

        if (quantityInput) {
          quantityInput.addEventListener('change', () => this.calculateTotal());
        }
      });

      this.addToCartBtn.addEventListener('click', this.onAddToCart.bind(this));

      // Shop Pay button logic
      this.shopPayBtnWrapper = this.querySelector('#group-buy-shop-pay-btn');
      if (this.shopPayBtnWrapper) {
        this.shopPayBtnWrapper.addEventListener('click', this.onShopPayClick.bind(this));
      }

      this.calculateTotal(); // initial calculation (should be 0 since default is 0)

      // Show Options / Collapse 切换
      this.items.forEach(item => {
        const toggleBtn = item.querySelector('[data-toggle]');
        if (!toggleBtn) return;
        toggleBtn.addEventListener('click', () => {
          const isOpen = item.classList.toggle('group-buy-item--open');
          toggleBtn.textContent = isOpen ? 'Collapse' : 'Show Options';
        });
      });

      // Presets Slider Navigation
      const presetBlocks = this.querySelectorAll('.variant-group-buy-presets');
      presetBlocks.forEach(block => {
        const presetSlider = block.querySelector('.group-buy-presets__slider');
        const prevBtn = block.querySelector('.preset-nav-btn.prev');
        const nextBtn = block.querySelector('.preset-nav-btn.next');
        if (presetSlider && prevBtn && nextBtn) {
          prevBtn.addEventListener('click', () => {
            presetSlider.scrollBy({ left: -200, behavior: 'smooth' });
          });
          nextBtn.addEventListener('click', () => {
            presetSlider.scrollBy({ left: 200, behavior: 'smooth' });
          });
        }
      });

      // Presets Click Handler
      const presetCards = this.querySelectorAll('.preset-card');
      presetCards.forEach(card => {
        card.addEventListener('click', () => {
          // Highlight active card
          presetCards.forEach(c => c.classList.remove('active'));
          card.classList.add('active');

          const itemsData = card.getAttribute('data-preset-items');
          if (!itemsData) return;

          let presetItems = {};
          try {
            presetItems = JSON.parse(itemsData);
          } catch (e) {
            console.error('Failed to parse preset items', e);
            return;
          }

          // Update quantities
          this.items.forEach(item => {
            const quantityInput = item.querySelector('.group-buy-quantity');
            if (quantityInput && !quantityInput.disabled) {
              const productId = String(item.dataset.productId);
              const newQty = presetItems[productId] !== undefined ? presetItems[productId] : 0;
              quantityInput.value = newQty;

              const inputEvent = new Event('change', { bubbles: true });
              quantityInput.dispatchEvent(inputEvent);

              const qtyInputWrap = item.querySelector('quantity-input');
              if (qtyInputWrap && qtyInputWrap.input) {
                qtyInputWrap.input.value = newQty;
              }
            }
          });

          const presetImage = card.getAttribute('data-preset-image') || '';
          const presetTitle = card.getAttribute('data-preset-title') || '';

          // Switch color variant if preset has a color field
          const presetColor = (card.getAttribute('data-preset-color') || '').trim();
          if (presetColor) {
            const variantSelects = this.querySelector('variant-selects');
            if (variantSelects) {
              const colorLower = presetColor.toLowerCase();

              // Try input[type=radio] (swatch or button picker)
              const allInputs = variantSelects.querySelectorAll('input[type="radio"]');
              let matched = null;
              allInputs.forEach(input => {
                if (input.value.toLowerCase() === colorLower) matched = input;
              });

              // Fallback: try button elements with data-value
              if (!matched) {
                variantSelects.querySelectorAll('button[data-value]').forEach(btn => {
                  if ((btn.getAttribute('data-value') || '').toLowerCase() === colorLower) matched = btn;
                });
              }

              if (matched) {
                // 注册 callback：toggleCombinationImg 的 setTimeout 完成后调用
                if (presetImage) {
                  window._presetGalleryOverlayCallback = () => {
                    this.showPresetGalleryOverlay(presetImage, presetTitle);
                  };
                } else {
                  window._presetGalleryOverlayCallback = null;
                  this.hidePresetGalleryOverlay();
                }

                if (matched.tagName === 'INPUT') {
                  if (!matched.checked && !matched.disabled) {
                    matched.checked = true;
                    matched.dispatchEvent(new Event('change', { bubbles: true }));
                  } else if (matched.checked) {
                    // 已选中同一颜色（不会触发 change → toggleCombinationImg），直接执行
                    if (presetImage) this.showPresetGalleryOverlay(presetImage, presetTitle);
                    window._presetGalleryOverlayCallback = null;
                  }
                } else {
                  if (!matched.disabled) matched.click();
                }
              } else {
                // 颜色找不到，直接执行
                if (presetImage) this.showPresetGalleryOverlay(presetImage, presetTitle);
              }
            }
          } else {
            // 无颜色字段，直接执行（无 toggleCombinationImg 介入）
            if (presetImage) {
              this.showPresetGalleryOverlay(presetImage, presetTitle);
            } else {
              this.hidePresetGalleryOverlay();
            }
          }
        });
      });

      // 初始化组合图浮层
      this.initPresetGalleryOverlay();

      // 主商品选项联动
      this.syncFromMainProduct();

      // Load cart to count existing eligible items
      this.loadCartEligibleQty();

      // Re-sync when cart changes (e.g. user removes items from cart drawer)
      // cart:refresh fires after add-to-cart; cart:updated fires after quantity change/remove in cart drawer
      const onCartChange = () => this.loadCartEligibleQty();
      document.addEventListener('cart:refresh', onCartChange, { signal: this._abortController.signal });
      document.addEventListener('cart:updated', onCartChange, { signal: this._abortController.signal });

      // 监听全局变体切换事件
      document.addEventListener('variant:custom-change', (e) => {
        const variantOrId = e.detail?.variantOrId;
        if (variantOrId) {
          this.updatePresetsVisibility(variantOrId);
        }
      }, { signal: this._abortController.signal });

      // 页面初次加载时，根据当前变体同步预设组合块的可见性
      const initialVariantId = this.dataset.selectedVariantId ||
        (() => {
          const script = this.querySelector('variant-selects [data-selected-variant]');
          try { return script ? JSON.parse(script.textContent.trim())?.id : null; } catch (_) { return null; }
        })();
      if (initialVariantId) {
        this.updatePresetsVisibility(initialVariantId);
      }
    }

    initPresetGalleryOverlay() {
      this._presetOverlayActive = false;
    }

    /**
     * 显示组合图：
     * 动态生成并 prepend 幻灯片到 Swiper wrapper，并通过 loopRecreate / update 更新 Swiper，
     * 自动滑动到第一张组合图。
     */
    showPresetGalleryOverlay(imageUrl, title) {
      // 找当前可见的 media-gallery
      let gallery = null;
      document.querySelectorAll('media-gallery.variant-gallery').forEach(g => {
        if (window.getComputedStyle(g).display !== 'none') gallery = g;
      });

      if (!gallery) {
        gallery = document.querySelector('media-gallery');
      }

      if (!gallery) {
        return;
      }

      // ---- 主橱窗图 ----
      const mainWrapper = gallery.querySelector('.product__media-list.swiper-wrapper') ||
                          gallery.querySelector('.product__media-gallery-viewer .swiper-wrapper');

      if (mainWrapper) {
        let mainSlot = mainWrapper.querySelector('[data-preset-slot="main"]');
        if (!mainSlot) {
          // 创建幻灯片并 prepend
          mainSlot = document.createElement('div');
          mainSlot.className = 'product__media-item swiper-slide';
          mainSlot.setAttribute('data-preset-slot', 'main');
          mainSlot.innerHTML = `
            <div
              class="product__media-item-container relative flex overflow-hidden blocks-radius media-type-image"
              style="--aspect-ratio:1.0; background:#f4f4f4; aspect-ratio:1/1; width:100%;"
            >
              <img src="${imageUrl}" alt="${title}" style="width:100%;height:100%;object-fit:contain;display:block;">
            </div>
          `;

          const mainSwiper = gallery.sliderInstance?.slider;
          if (mainSwiper && !mainSwiper.destroyed) {
            if (mainSwiper.params.loop && typeof mainSwiper.loopDestroy === 'function') {
              mainSwiper.loopDestroy();
            }

            mainWrapper.prepend(mainSlot);

            if (mainSwiper.params.loop && typeof mainSwiper.loopCreate === 'function') {
              mainSwiper.loopCreate();
            }
            mainSwiper.update();
            requestAnimationFrame(() => {
              if (!mainSwiper.destroyed) {
                mainSwiper.slideToLoop(0, 300, false);
              }
            });
          } else {
            mainWrapper.prepend(mainSlot);
          }
        } else {
          // 已存在，只更新 img src / alt
          const img = mainSlot.querySelector('img');
          if (img) {
            img.src = imageUrl;
            img.alt = title;
          }
          const mainSwiper = gallery.sliderInstance?.slider;
          if (mainSwiper && !mainSwiper.destroyed) {
            mainWrapper.querySelectorAll('[data-preset-slot="main"] img').forEach(cloneImg => {
              cloneImg.src = imageUrl;
              cloneImg.alt = title;
            });
            mainSwiper.update();
            requestAnimationFrame(() => {
              if (!mainSwiper.destroyed) {
                mainSwiper.slideToLoop(0, 300, false);
              }
            });
          }
        }
      }

      // ---- 缩略图 ----
      const thumbsWrapper = gallery.querySelector('.thumbnail-list.swiper-wrapper') ||
                            gallery.querySelector('.product__media-gallery-thumbails .swiper-wrapper');

      if (thumbsWrapper) {
        let thumbSlot = thumbsWrapper.querySelector('[data-preset-slot="thumb"]');
        if (!thumbSlot) {
          // 创建缩略图并 prepend
          thumbSlot = document.createElement('div');
          thumbSlot.className = 'product__thumbs-item swiper-slide';
          thumbSlot.setAttribute('data-preset-slot', 'thumb');

          const realThumb = thumbsWrapper.querySelector('.product__thumbs-item[data-target]');
          const thumbMargin = realThumb?.style.marginBottom || '';
          if (thumbMargin) thumbSlot.style.marginBottom = thumbMargin;

          thumbSlot.innerHTML = `
            <div class="product__thumbs-container relative blocks-radius-md media-wrapper cursor-pointer" style="background:#f4f4f4;">
              <div class="product__thumbs-inner" style="--aspect-ratio: 1">
                <img src="${imageUrl}" alt="${title}" style="width:100%;height:100%;object-fit:contain;">
              </div>
            </div>
          `;

          const thumbsSwiper = gallery.thumbsInstance?.slider;
          if (thumbsSwiper && !thumbsSwiper.destroyed) {
            if (thumbsSwiper.params.loop && typeof thumbsSwiper.loopDestroy === 'function') {
              thumbsSwiper.loopDestroy();
            }

            thumbsWrapper.prepend(thumbSlot);

            if (thumbsSwiper.params.loop && typeof thumbsSwiper.loopCreate === 'function') {
              thumbsSwiper.loopCreate();
            }
            thumbsSwiper.update();
            requestAnimationFrame(() => {
              if (!thumbsSwiper.destroyed) {
                thumbsSwiper.slideTo(0, 0, false);
              }
            });
          } else {
            thumbsWrapper.prepend(thumbSlot);
          }
        } else {
          // 已存在，只更新 img src / alt
          const img = thumbSlot.querySelector('img');
          if (img) {
            img.src = imageUrl;
            img.alt = title;
          }
          const thumbsSwiper = gallery.thumbsInstance?.slider;
          if (thumbsSwiper && !thumbsSwiper.destroyed) {
            thumbsWrapper.querySelectorAll('[data-preset-slot="thumb"] img').forEach(cloneImg => {
              cloneImg.src = imageUrl;
              cloneImg.alt = title;
            });
            thumbsSwiper.update();
            requestAnimationFrame(() => {
              if (!thumbsSwiper.destroyed) {
                thumbsSwiper.slideTo(0, 0, false);
              }
            });
          }
        }
      }

      this._presetOverlayActive = true;
    }

    /**
     * 隐藏组合图：
     * 从 DOM 中移除幻灯片，并通过 loopRecreate / update 更新 Swiper，并复位到第一张。
     */
    hidePresetGalleryOverlay() {
      if (!this._presetOverlayActive) return;

      document.querySelectorAll('media-gallery').forEach(gallery => {
        // ---- 主商品图 ----
        const mainWrapper = gallery.querySelector('.product__media-list.swiper-wrapper') ||
                            gallery.querySelector('.product__media-gallery-viewer .swiper-wrapper');
        const mainSwiper = gallery.sliderInstance?.slider;

        if (mainWrapper) {
          const mainSlot = mainWrapper.querySelector('[data-preset-slot="main"]');
          if (mainSlot) {
            if (mainSwiper && !mainSwiper.destroyed) {
              if (mainSwiper.params.loop && typeof mainSwiper.loopDestroy === 'function') {
                mainSwiper.loopDestroy();
              }

              mainWrapper.querySelectorAll('[data-preset-slot="main"]').forEach(el => el.remove());

              if (mainSwiper.params.loop && typeof mainSwiper.loopCreate === 'function') {
                mainSwiper.loopCreate();
              }
              mainSwiper.update();
              requestAnimationFrame(() => {
                if (!mainSwiper.destroyed) {
                  mainSwiper.slideToLoop(0, 0, false);
                }
              });
            } else {
              mainWrapper.querySelectorAll('[data-preset-slot="main"]').forEach(el => el.remove());
            }
          }
        }

        // ---- 缩略图 ----
        const thumbsWrapper = gallery.querySelector('.thumbnail-list.swiper-wrapper') ||
                              gallery.querySelector('.product__media-gallery-thumbails .swiper-wrapper');
        const thumbsSwiper = gallery.thumbsInstance?.slider;

        if (thumbsWrapper) {
          const thumbSlot = thumbsWrapper.querySelector('[data-preset-slot="thumb"]');
          if (thumbSlot) {
            if (thumbsSwiper && !thumbsSwiper.destroyed) {
              if (thumbsSwiper.params.loop && typeof thumbsSwiper.loopDestroy === 'function') {
                thumbsSwiper.loopDestroy();
              }

              thumbsWrapper.querySelectorAll('[data-preset-slot="thumb"]').forEach(el => el.remove());

              if (thumbsSwiper.params.loop && typeof thumbsSwiper.loopCreate === 'function') {
                thumbsSwiper.loopCreate();
              }
              thumbsSwiper.update();
              requestAnimationFrame(() => {
                if (!thumbsSwiper.destroyed) {
                  thumbsSwiper.slideTo(0, 0, false);
                }
              });
            } else {
              thumbsWrapper.querySelectorAll('[data-preset-slot="thumb"]').forEach(el => el.remove());
            }
          }
        }
      });

      this._presetOverlayActive = false;
    }

    updatePresetsVisibility(variantOrId) {
      let variantId = null;
      if (typeof variantOrId === 'object' && variantOrId !== null) {
        variantId = String(variantOrId.id);
      } else if (variantOrId) {
        variantId = String(variantOrId);
      }
      if (!variantId) return;

      // 锁住 header 当前高度，防止 preset block 显隐引起布局撑开/收缩，
      // 从而避免视口内容位移（用户看起来像"滚动到了组合图"）
      const header = this.querySelector('.group-buy-header');
      if (header) {
        header.style.minHeight = header.offsetHeight + 'px';
      }

      let hasVisiblePresets = false;
      const presetsBlocks = this.querySelectorAll('.variant-group-buy-presets');
      presetsBlocks.forEach(block => {
        if (block.dataset.variantId === variantId) {
          block.style.display = '';
          hasVisiblePresets = true;
        } else {
          block.style.display = 'none';
        }
      });

      // const titleBlock = this.querySelector('.group-buy-presets-make-it-your-own');
      // if (titleBlock) {
      //   titleBlock.style.display = hasVisiblePresets ? '' : 'none';
      // }

      // 布局稳定后释放高度锁
      requestAnimationFrame(() => {
        if (header) header.style.minHeight = '';
      });
    }

    resetPresetsAndQuantities() {
      this.hidePresetGalleryOverlay();
      this.querySelectorAll('.preset-card').forEach(c => c.classList.remove('active'));
      this.items.forEach(item => {
        const quantityInput = item.querySelector('.group-buy-quantity');
        if (quantityInput && !quantityInput.disabled) {
          if (quantityInput.value !== '0') {
            quantityInput.value = 0;
            quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          const qtyInputWrap = item.querySelector('quantity-input');
          if (qtyInputWrap && qtyInputWrap.input) {
            qtyInputWrap.input.value = 0;
          }
        }
      });
    }

    /**
     * 监听主商品（variant-selects）的选项变化，
     * 若子商品有相同名称的 option，自动同步到相同值。
     */
    syncFromMainProduct() {
      // 只查找本 group-buy-form 内部的 variant-selects（主商品选项区）
      const variantSelects = this.querySelector('variant-selects');
      if (!variantSelects) return;

      // 从 fieldset 中获取 option 名称（legend 内 .font-body-bolder 的文字去掉冒号）
      const getOptionName = (fieldset) => {
        const nameEl = fieldset.querySelector('.font-body-bolder');
        return nameEl ? nameEl.textContent.replace(':', '').trim() : null;
      };

      // 将某个值同步到指定子商品中具有相同值的 option
      const syncOptionToItem = (item, optionValue) => {
        let synced = false;
        if (!optionValue) return synced;
        const fieldsets = item.querySelectorAll('fieldset[class*="product-form__input"]');
        fieldsets.forEach(fieldset => {
          let targetRadio = null;
          const radios = Array.from(fieldset.querySelectorAll('.group-buy-radio'));

          // 1. 精确匹配优先
          targetRadio = radios.find(radio => radio.value === optionValue);

          // 2. 如果没找到，尝试忽略大小写和空格的互相包含匹配
          if (!targetRadio) {
            const searchVal = optionValue.trim().toLowerCase();
            targetRadio = radios.find(radio => {
              const radioVal = radio.value.trim().toLowerCase();
              return searchVal.includes(radioVal);
            });
          }

          if (!targetRadio) return;

          synced = true;
          if (targetRadio.checked) return;

          targetRadio.checked = true;

          // 同步隐藏 select
          const optionIndex = targetRadio.dataset.optionIndex;
          const hiddenSelect = item.querySelector(`.group-buy-select[data-index="${optionIndex}"]`);
          if (hiddenSelect) {
            hiddenSelect.value = optionValue;
            // 更新 legend 显示文字
            const labelEl = fieldset.querySelector('[data-selected-option-value]');
            if (labelEl) labelEl.textContent = optionValue;
            // 触发变体更新
            hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        return synced;
      };

      // 使用事件委托绑定到 group-buy-form，防止由于 variant-selects DOM 替换导致事件丢失
      this.addEventListener('change', (event) => {
        const target = event.target;

        // 匹配主商品 radio 变化
        if (target.matches('variant-selects input[type="radio"]')) {
          if (!target.checked) return;

          this.resetPresetsAndQuantities();

          const fieldset = target.closest('fieldset');
          if (fieldset) {
            const selectedLabel = fieldset.querySelector('[data-selected-swatch-value]');
            if (selectedLabel) selectedLabel.textContent = target.value;
          }

          const fallbackValue = target.dataset.fallbackValue;
          this.items.forEach(item => {
            const synced = syncOptionToItem(item, target.value);
            if (!synced && fallbackValue) {
              syncOptionToItem(item, fallbackValue);
            }
          });
        }

        // 匹配主商品 select 变化（排除子商品的 select）
        else if (target.matches('variant-selects select:not(.group-buy-select)')) {
          this.resetPresetsAndQuantities();

          const wrapper = target.closest('[data-option-name]');
          if (wrapper) {
            const selectedLabel = wrapper.querySelector('[data-selected-swatch-value]');
            if (selectedLabel) selectedLabel.textContent = target.value;
          }

          const selectedOption = target.options[target.selectedIndex];
          const fallbackValue = selectedOption ? selectedOption.dataset.fallbackValue : null;

          this.items.forEach(item => {
            const synced = syncOptionToItem(item, target.value);
            if (!synced && fallbackValue) {
              syncOptionToItem(item, fallbackValue);
            }
          });
        }
      });

      // 页面初次加载时，主动执行一次当前主商品选中值到子商品的同步
      const syncAllFromCurrentSelection = () => {
        const checkedRadios = variantSelects.querySelectorAll('fieldset input[type="radio"]:checked');
        if (checkedRadios.length > 0) {
          checkedRadios.forEach(radio => {
            const fallbackValue = radio.dataset.fallbackValue;
            this.items.forEach(item => {
              const synced = syncOptionToItem(item, radio.value);
              if (!synced && fallbackValue) {
                syncOptionToItem(item, fallbackValue);
              }
            });
          });
        } else {
          const selects = variantSelects.querySelectorAll('select:not(.group-buy-select)');
          selects.forEach(select => {
            if (select.selectedIndex >= 0) {
              const selectedOption = select.options[select.selectedIndex];
              const fallbackValue = selectedOption ? selectedOption.dataset.fallbackValue : null;
              this.items.forEach(item => {
                const synced = syncOptionToItem(item, select.value);
                if (!synced && fallbackValue) {
                  syncOptionToItem(item, fallbackValue);
                }
              });
            }
          });
        }
      };

      syncAllFromCurrentSelection();
    }

    onVariantChange(item) {
      const variantsData = item.querySelector('[data-variants]').textContent;
      let variants = [];
      try {
        variants = JSON.parse(variantsData);
      } catch (e) {
        console.error("Failed to parse variants data", e);
        return;
      }

      const selects = item.querySelectorAll('.group-buy-select');
      const options = Array.from(selects).map(select => select.value);

      const currentVariant = variants.find(variant => {
        return !variant.options.some((option, index) => {
          return options[index] !== option;
        });
      });

      if (!currentVariant) return;

      // Update Variant Info
      const titleEl = item.querySelector('[data-variant-title]');
      if (titleEl) titleEl.textContent = currentVariant.title;

      const priceEl = item.querySelector('[data-price]');
      if (priceEl) {
        const salePrice = currentVariant.price;
        const comparePrice = currentVariant.compare_at_price || 0;
        const isOnSale = comparePrice > salePrice;

        priceEl.dataset.price = salePrice;
        priceEl.dataset.comparePrice = comparePrice;

        // 切换 on-sale 样式类
        priceEl.classList.toggle('f-price--on-sale', isOnSale);

        // 格式化价格
        const formattedSale = FoxTheme.Currency.formatMoney(salePrice, FoxTheme.settings.moneyFormat);
        const formattedCompare = FoxTheme.Currency.formatMoney(comparePrice, FoxTheme.settings.moneyFormat);

        // 更新普通价格区（无划线价时显示）
        const regularEl = priceEl.querySelector('.f-price__regular .f-price-item--regular');
        if (regularEl) regularEl.innerHTML = formattedSale;

        // 更新划线价区（有划线价时显示）
        const salePriceEl = priceEl.querySelector('.f-price__sale .f-price-item--sale');
        if (salePriceEl) salePriceEl.innerHTML = formattedSale;

        const compareEl = priceEl.querySelector('.f-price__sale .f-price-item--regular s');
        if (compareEl) compareEl.innerHTML = formattedCompare;
      }

      const skuEl = item.querySelector('[data-sku]');
      if (skuEl) {
        skuEl.textContent = currentVariant.sku ? `SKU: ${currentVariant.sku}` : '';
      }

      const availabilityEl = item.querySelector('[data-availability]');
      if (availabilityEl) {
        availabilityEl.textContent = currentVariant.available ? 'In Stock' : 'Out of Stock';
      }

      const imageEl = item.querySelector('img[data-image]');
      if (imageEl && currentVariant.featured_image && currentVariant.featured_image.src) {
        imageEl.src = currentVariant.featured_image.src;
        imageEl.srcset = currentVariant.featured_image.src;
      }

      // Update Quantity Input
      const quantityInput = item.querySelector('.group-buy-quantity');
      if (quantityInput) {
        if (!currentVariant.available) {
          quantityInput.value = 0;
          quantityInput.disabled = true;
          // Trigger change to update total
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          quantityInput.disabled = false;
        }
      }

      // We recalculate total since price might have changed
      this.calculateTotal();
    }

    calculateTotal() {
      const tiers = (window.PRODUCT_GROUP_CONFIG?.discountTiers) || [];

      // Gather selection data
      let selectionEligibleQty = 0;
      let rawEligibleTotal = 0;
      let rawNonEligibleTotal = 0;

      this.items.forEach(item => {
        const quantityInput = item.querySelector('.group-buy-quantity');
        const priceEl = item.querySelector('[data-price]');
        if (!quantityInput || !priceEl) return;

        const qty = parseInt(quantityInput.value, 10) || 0;
        if (qty === 0) return;

        const price = parseInt(priceEl.dataset.price, 10) || 0;
        const isEligible = item.dataset.discountEligible === 'true';

        if (isEligible) {
          selectionEligibleQty += qty;
          rawEligibleTotal += qty * price;
        } else {
          rawNonEligibleTotal += qty * price;
        }
      });

      // Total eligible qty = cart existing + current selection
      const totalEligibleQty = this.cartEligibleQty + selectionEligibleQty;

      // Find applicable tier (highest tier where totalEligibleQty >= minQty)
      let currentTier = null;
      for (let i = tiers.length - 1; i >= 0; i--) {
        if (totalEligibleQty >= tiers[i].minQty) {
          currentTier = tiers[i];
          break;
        }
      }

      const discountRate = currentTier?.discountRate || 0;
      const discountedEligibleTotal = Math.round(rawEligibleTotal * (1 - discountRate));
      const total = discountedEligibleTotal + rawNonEligibleTotal;
      const hasDiscount = discountRate > 0 && rawEligibleTotal > 0;

      // Update total price display
      if (this.totalPriceEl) {
        this.totalPriceEl.innerHTML = FoxTheme.Currency.formatMoney(total, FoxTheme.settings.moneyFormat);
        this.totalPriceEl.classList.toggle('group-buy-total__sale-price--active', hasDiscount);
      }

      // Update compare price (original before N-piece discount)
      if (this.totalComparePriceEl) {
        if (hasDiscount) {
          const compareTotal = rawEligibleTotal + rawNonEligibleTotal;
          this.totalComparePriceEl.innerHTML = FoxTheme.Currency.formatMoney(compareTotal, FoxTheme.settings.moneyFormat);
          this.totalComparePriceEl.classList.remove('hidden');
        } else {
          this.totalComparePriceEl.classList.add('hidden');
        }
      }

      // Render selections list and tier info
      this.renderSelections(discountRate);
      this.renderTierInfo(totalEligibleQty, currentTier, tiers);
    }

    // Fetch cart and count eligible items already in cart
    async loadCartEligibleQty() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();

        // Build set of eligible product IDs from this form
        const eligibleIds = new Set();
        this.items.forEach(item => {
          if (item.dataset.discountEligible === 'true') {
            eligibleIds.add(String(item.dataset.productId));
          }
        });

        let qty = 0;
        cart.items.forEach(cartItem => {
          if (eligibleIds.has(String(cartItem.product_id))) {
            qty += cartItem.quantity;
          }
        });

        this.cartEligibleQty = qty;
        this.calculateTotal(); // recalculate now that we have cart data
      } catch (e) {
        this.cartEligibleQty = 0;
      }
    }

    // Render "Your Selections" item rows
    renderSelections(discountRate) {
      const selEl = this.querySelector('#group-buy-selections');
      const wrapperEl = this.querySelector('#group-buy-selections-wrapper');
      if (!selEl) return;

      const rows = [];
      this.items.forEach(item => {
        const qty = parseInt(item.querySelector('.group-buy-quantity')?.value, 10) || 0;
        if (qty === 0) return;

        const title = item.dataset.productTitle || item.querySelector('.group-buy-item__title')?.textContent?.trim() || '';
        const priceEl = item.querySelector('[data-price]');
        const price = parseInt(priceEl?.dataset.price, 10) || 0;
        const isEligible = item.dataset.discountEligible === 'true';

        const subtotal = qty * price;
        const discountedSubtotal = (isEligible && discountRate > 0) ? Math.round(subtotal * (1 - discountRate)) : subtotal;
        const hasItemDiscount = isEligible && discountRate > 0;

        const fmt = (v) => FoxTheme.Currency.formatMoney(v, FoxTheme.settings.moneyFormat);
        const priceDisplay = hasItemDiscount
          ? `${fmt(discountedSubtotal)} <s>${fmt(subtotal)}</s>`
          : fmt(subtotal);
        rows.push(`
          <div class="group-buy-selection-row">
            <span class="group-buy-selection-name">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 14"><title>Checkmark</title><g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="square" stroke-width="2"><path d="m11.357 5.286-6.364 6.363M1.457 8.114l3.536 3.535"/></g>
            </svg> ${title}: Quantity ${qty}</span>
            <span class="group-buy-selection-price">${priceDisplay}</span>
          </div>
        `);
      });

      selEl.innerHTML = rows.join('');
      if (wrapperEl) wrapperEl.classList.toggle('hidden', rows.length === 0);
    }

    // Render tier unlock info and next tier hint
    renderTierInfo(totalEligibleQty, currentTier, tiers) {
      const tierEl = this.querySelector('#group-buy-tier-info');
      if (!tierEl) return;

      let html = '';

      if (currentTier && currentTier.discountRate > 0) {
        const pct = Math.round(currentTier.discountRate * 100);
        html += `<p class="group-buy-tier-unlocked">🎉 You've unlocked ${pct}% OFF on your selection.</p>`;
      }

      const nextTier = tiers.find(t => t.minQty > totalEligibleQty);
      if (nextTier) {
        const needed = nextTier.minQty - totalEligibleQty;
        const nextPct = Math.round(nextTier.discountRate * 100);
        html += `<p class="group-buy-tier-next">Add ${needed} more piece${needed > 1 ? 's' : ''} to unlock ${nextPct}% OFF.</p>`;
      }

      tierEl.innerHTML = html;
    }

    onShopPayClick(e) {
      e.preventDefault();
      this.errorEl.classList.add('hidden');

      if (this.shopPayBtnWrapper.classList.contains('is-loading')) return;

      const itemsToAdd = [];

      this.items.forEach(item => {
        const quantityInput = item.querySelector('.group-buy-quantity');
        const qty = parseInt(quantityInput?.value, 10) || 0;

        if (qty > 0) {
          const variantsData = item.querySelector('[data-variants]').textContent;
          let variants = [];
          try {
            variants = JSON.parse(variantsData);
          } catch (e) {
            return;
          }

          const selects = item.querySelectorAll('.group-buy-select');
          if (selects.length > 0) {
            const options = Array.from(selects).map(select => select.value);
            const currentVariant = variants.find(variant => {
              return !variant.options.some((option, index) => {
                return options[index] !== option;
              });
            });
            if (currentVariant && currentVariant.available) {
              itemsToAdd.push({
                id: currentVariant.id,
                quantity: qty
              });
            }
          } else {
            // Default variant
            if (variants.length > 0 && variants[0].available) {
              itemsToAdd.push({
                id: variants[0].id,
                quantity: qty
              });
            }
          }
        }
      });

      if (itemsToAdd.length === 0) {
        this.errorEl.textContent = 'Please Make Selection Before Checking Out';
        this.errorEl.classList.remove('hidden');
        return;
      }

      this.shopPayBtnWrapper.classList.add('is-loading');
      this.shopPayBtnWrapper.style.opacity = '0.7';
      this.shopPayBtnWrapper.style.pointerEvents = 'none';

      const checkoutItemsStr = itemsToAdd.reverse().map(item => `${item.id}:${item.quantity}`).join(',');
      window.location.href = `/cart/${checkoutItemsStr}`;
    }

    onAddToCart(e) {
      e.preventDefault();
      this.errorEl.classList.add('hidden');
      this.addToCartBtn.classList.add('btn--loading');
      this.addToCartBtn.disabled = true;

      const itemsToAdd = [];

      this.items.forEach(item => {
        const quantityInput = item.querySelector('.group-buy-quantity');
        const qty = parseInt(quantityInput?.value, 10) || 0;

        if (qty > 0) {
          const variantsData = item.querySelector('[data-variants]').textContent;
          let variants = [];
          try {
            variants = JSON.parse(variantsData);
          } catch (e) {
            return;
          }

          const selects = item.querySelectorAll('.group-buy-select');
          if (selects.length > 0) {
            const options = Array.from(selects).map(select => select.value);
            const currentVariant = variants.find(variant => {
              return !variant.options.some((option, index) => {
                return options[index] !== option;
              });
            });
            if (currentVariant && currentVariant.available) {
              itemsToAdd.push({
                id: currentVariant.id,
                quantity: qty
              });
            }
          } else {
            // Default variant
            if (variants.length > 0 && variants[0].available) {
              itemsToAdd.push({
                id: variants[0].id,
                quantity: qty
              });
            }
          }
        }
      });

      if (itemsToAdd.length === 0) {
        this.errorEl.textContent = 'Please Make Selection Before Adding to Cart';
        this.errorEl.classList.remove('hidden');
        this.addToCartBtn.classList.remove('btn--loading');
        this.addToCartBtn.disabled = false;
        return;
      }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: itemsToAdd })
      })
        .then(response => response.json())
        .then(parsedState => {
          if (parsedState.status) {
            this.errorEl.textContent = parsedState.description || 'Error adding to cart';
            this.errorEl.classList.remove('hidden');
            return;
          }

          // 触发 cart:refresh，让 cart-drawer 重新获取最新 section HTML 并刷新内容，然后打开
          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { open: true },
            })
          );

          // Reset quantities to 0 after success
          this.items.forEach(item => {
            const quantityInput = item.querySelector('.group-buy-quantity');
            if (quantityInput && !quantityInput.disabled) {
              quantityInput.value = 0;
              const inputEvent = new Event('change', { bubbles: true });
              quantityInput.dispatchEvent(inputEvent);

              // Try to trigger the custom quantity-input component update if it exists
              const qtyInputWrap = item.querySelector('quantity-input');
              if (qtyInputWrap && qtyInputWrap.input) {
                qtyInputWrap.input.value = 0;
              }
            }
          });

          // Refresh cart eligible qty so tier info reflects the newly added items.
          // Note: cart:refresh event (dispatched above) already triggers loadCartEligibleQty().
          // No need to call it again here.
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          this.errorEl.textContent = 'Something went wrong. Please try again.';
          this.errorEl.classList.remove('hidden');
        })
        .finally(() => {
          this.addToCartBtn.classList.remove('btn--loading');
          this.addToCartBtn.disabled = false;
        });
    }
  });
}
